import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectTimesheetValue } from '../../../../../../../../../../services/timesheets/selectors';

interface Props {
    workTypeName?: number;
}

export class TimesheetWorkTypeName extends React.PureComponent<Props> {
    render() {
        const { workTypeName } = this.props;
        if (!workTypeName) return null;
        return workTypeName;
    }
}

const mapStateToProps = createStructuredSelector({
    workTypeName: makeSelectTimesheetValue('workTypeName')
});

export default connect(mapStateToProps)(TimesheetWorkTypeName);
